import { driver } from "driver.js";
import "driver.js/dist/driver.css";

// --- LOCALSTORAGE KEY ---
var STORAGE_KEY = "tutorials_completed";

// --- ROUTE-TO-SECTION MAPPING ---
var ROUTE_SECTION_MAP = {
  "/inicio": "inicio",
  "/clientes": "clientes",
  "/facturas": "facturas",
  "/productos": "productos",
  "/pedidos": "pedidos",
  "/categorias": "categorias",
  "/whatsapp": "whatsapp",
  "/whatsapp/config": "whatsapp_config",
  "/whatsapp/asistente": "whatsapp_asistente"
};

// --- TOUR DEFINITIONS ---
var TOUR_STEPS = {
  inicio: [
    {
      popover: {
        title: "Bienvenido al Dashboard",
        description:
          "Este es tu panel de control de Mundo Bandera. Aqui puedes ver un resumen completo de tu negocio: ventas, pedidos, clientes y WhatsApp. Te mostramos cada seccion.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='inicio-stats']",
      popover: {
        title: "Indicadores Principales",
        description:
          "Ventas totales, numero de facturas, pedidos y costos de envio. Estos numeros se actualizan en tiempo real.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='inicio-stats2']",
      popover: {
        title: "Indicadores Secundarios",
        description:
          "Clientes activos, productos en catalogo, mensajes de WhatsApp de hoy y chats activos con Vexi o asesor humano.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='inicio-charts']",
      popover: {
        title: "Graficas",
        description:
          "A la izquierda: mensajes de WhatsApp de los ultimos 30 dias. A la derecha: distribucion de pedidos por estatus (pendiente, en camino, entregado, etc.).",
        side: "top",
        align: "center"
      }
    },
    {
      element: "[data-tour='inicio-ventas']",
      popover: {
        title: "Ventas y Pedidos Recientes",
        description:
          "Grafica de ventas mensuales y la tabla de pedidos mas recientes con su estatus y costo de envio.",
        side: "top",
        align: "center"
      }
    },
    {
      element: "[data-tour='inicio-conversaciones']",
      popover: {
        title: "Conversaciones Recientes",
        description:
          "Las ultimas conversaciones de WhatsApp. Haz clic en 'Ver todas' para ir a la seccion completa de WhatsApp.",
        side: "top",
        align: "center"
      }
    }
  ],

  clientes: [
    {
      popover: {
        title: "Seccion de Clientes",
        description:
          "Aqui gestionas todos los clientes de Mundo Bandera. Puedes crear nuevos, editar sus datos, ver su perfil y controlar su estado.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='clientes-stats']",
      popover: {
        title: "Estadisticas de Clientes",
        description:
          "Resumen rapido: total de clientes, registros de los ultimos 7 dias, clientes activos e inactivos.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='clientes-nuevo']",
      popover: {
        title: "Nuevo Cliente",
        description:
          "Haz clic aqui para registrar un nuevo cliente. Se abre un formulario con nombre, correo, telefono y direccion.",
        side: "left",
        align: "center"
      }
    },
    {
      element: "[data-tour='clientes-buscar']",
      popover: {
        title: "Buscar Clientes",
        description:
          "Escribe cualquier dato para filtrar clientes en tiempo real: nombre, email, telefono, etc.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='clientes-tabla']",
      popover: {
        title: "Tabla de Clientes",
        description:
          "Lista todos tus clientes con sus datos. Puedes ordenar por columnas, activar/desactivar un cliente y usar los botones de acciones para ver perfil, editar o eliminar.",
        side: "top",
        align: "center"
      }
    }
  ],

  facturas: [
    {
      popover: {
        title: "Seccion de Facturas",
        description:
          "Administra tus facturas. Crea nuevas con productos del catalogo, revisa el historial y controla tus ventas.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='facturas-stats']",
      popover: {
        title: "Resumen de Facturacion",
        description:
          "Total de facturas emitidas, monto total de ventas, facturas activas y canceladas.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='facturas-nueva']",
      popover: {
        title: "Nueva Factura",
        description:
          "Crea una factura seleccionando cliente, datos fiscales (RFC, CFDI) y agrega productos al carrito. El sistema calcula subtotal, IVA (16%) y total automaticamente.",
        side: "left",
        align: "center"
      }
    },
    {
      element: "[data-tour='facturas-tabla']",
      popover: {
        title: "Tabla de Facturas",
        description:
          "Lista completa con folio, cliente, razon social, productos, subtotal, IVA y total. Haz clic en el icono del ojo para ver el detalle completo de cualquier factura.",
        side: "top",
        align: "center"
      }
    }
  ],

  productos: [
    {
      popover: {
        title: "Catalogo de Productos",
        description:
          "Gestiona todos los productos de Mundo Bandera. Cada producto puede tener hasta 5 imagenes y multiples precios por medida.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='productos-stats']",
      popover: {
        title: "Estadisticas de Productos",
        description:
          "Total de productos, registros recientes, productos activos e inactivos en tu catalogo.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='productos-tabla']",
      popover: {
        title: "Tabla de Productos",
        description:
          "Cada producto muestra imagen, nombre, categoria, material, base y estado. Usa el boton '$' para gestionar los precios por medida (ej: 90x60cm = $150).",
        side: "top",
        align: "center"
      }
    }
  ],

  pedidos: [
    {
      popover: {
        title: "Seccion de Pedidos",
        description:
          "Gestiona los envios y seguimiento de pedidos. Cada pedido se vincula a una factura y tiene un folio de seguimiento.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='pedidos-stats']",
      popover: {
        title: "Resumen de Pedidos",
        description:
          "Total de pedidos, registros recientes, costo total de envios y clientes unicos que han hecho pedidos.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='pedidos-tabla']",
      popover: {
        title: "Tabla de Pedidos",
        description:
          "Cada pedido muestra cliente, factura, paqueteria, folio de seguimiento, costo y estatus con colores: naranja = en recoleccion, azul = en transito, verde = entregado, rojo = retrasado.",
        side: "top",
        align: "center"
      }
    }
  ],

  categorias: [
    {
      popover: {
        title: "Categorias de Productos",
        description:
          "Organiza tus productos en categorias. Cada categoria puede tener una imagen y descripcion representativa.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='categorias-stats']",
      popover: {
        title: "Resumen de Categorias",
        description:
          "Total de categorias, registros recientes, activas e inactivas.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='categorias-nueva']",
      popover: {
        title: "Nueva Categoria",
        description:
          "Crea una nueva categoria con nombre, descripcion e imagen. Los productos se asignan a estas categorias.",
        side: "left",
        align: "center"
      }
    },
    {
      element: "[data-tour='categorias-tabla']",
      popover: {
        title: "Tabla de Categorias",
        description:
          "Lista de categorias con imagen, nombre, descripcion, fecha y estado. Puedes activar/desactivar, editar o eliminar.",
        side: "top",
        align: "center"
      }
    }
  ],

  whatsapp: [
    {
      popover: {
        title: "WhatsApp - Conversaciones",
        description:
          "Aqui ves y gestionas todas las conversaciones de WhatsApp. Vexi, tu asistente de IA, atiende automaticamente a los clientes.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='whatsapp-stats']",
      popover: {
        title: "Estado de Conversaciones",
        description:
          "Total de conversaciones, cuantas atiende Vexi (bot IA), cuantas atiende un asesor humano y cuantas estan cerradas.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='whatsapp-filtros']",
      popover: {
        title: "Filtros Rapidos",
        description:
          "Filtra las conversaciones: Todas, Vexi (atendidas por el bot), Humano (transferidas a un asesor) o Cerradas.",
        side: "bottom",
        align: "center"
      }
    },
    {
      element: "[data-tour='whatsapp-tabla']",
      popover: {
        title: "Tabla de Conversaciones",
        description:
          "Cada conversacion muestra contacto, ultimo mensaje, estado, asesor asignado y cantidad de mensajes. Haz clic en 'Ver chat' para abrir la conversacion completa.",
        side: "top",
        align: "center"
      }
    },
    {
      element: "[data-tour='whatsapp-config-btn']",
      popover: {
        title: "Configuracion",
        description:
          "'Configurar WhatsApp' para vincular tu numero. 'Configurar Vexi' para personalizar las reglas y comportamiento del asistente de IA.",
        side: "bottom",
        align: "center"
      }
    }
  ],

  whatsapp_config: [
    {
      popover: {
        title: "Configurar WhatsApp",
        description:
          "Vincula tu numero de WhatsApp al sistema escaneando un codigo QR, igual que WhatsApp Web.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='config-qr']",
      popover: {
        title: "Codigo QR y Estado",
        description:
          "Cuando aparezca el QR, escanealo desde tu telefono en WhatsApp > Dispositivos vinculados. El estado cambiara a 'Conectado' automaticamente.",
        side: "right",
        align: "center"
      }
    },
    {
      element: "[data-tour='config-instrucciones']",
      popover: {
        title: "Instrucciones Paso a Paso",
        description:
          "Sigue estos 4 pasos para vincular tu WhatsApp correctamente. Una vez conectado, los mensajes de clientes llegaran al sistema.",
        side: "left",
        align: "center"
      }
    },
    {
      element: "[data-tour='config-negocio']",
      popover: {
        title: "Datos del Negocio",
        description:
          "Configura el nombre de tu negocio. Este dato se usa internamente para identificar la sesion de WhatsApp.",
        side: "left",
        align: "center"
      }
    }
  ],

  whatsapp_asistente: [
    {
      popover: {
        title: "Configurar Vexi",
        description:
          "Vexi es tu asistente de inteligencia artificial que atiende automaticamente las conversaciones de WhatsApp. Aqui defines su comportamiento.",
        side: "over",
        align: "center"
      }
    },
    {
      element: "[data-tour='asistente-prompt']",
      popover: {
        title: "Reglas del Asistente",
        description:
          "El 'System Prompt' define la personalidad y reglas de Vexi: como saluda, que puede vender, como responde a preguntas frecuentes, etc. Editalo libremente.",
        side: "right",
        align: "center"
      }
    },
    {
      element: "[data-tour='asistente-productos']",
      popover: {
        title: "Contexto de Productos",
        description:
          "Este texto se inyecta automaticamente para que Vexi conozca tu catalogo. Usa 'Regenerar desde catalogo' para actualizar con los productos actuales de la base de datos.",
        side: "right",
        align: "center"
      }
    },
    {
      element: "[data-tour='asistente-parametros']",
      popover: {
        title: "Parametros de IA",
        description:
          "Modelo de IA, temperatura (creatividad), tokens maximos (largo de respuesta) y mensajes de contexto (cuantos mensajes previos recuerda Vexi en cada respuesta).",
        side: "left",
        align: "center"
      }
    }
  ]
};

// --- SERVICE ---
var TutorialService = {
  _driverInstance: null,
  _isRunning: false,

  getSectionForRoute: function (routePath) {
    var cleanPath = routePath.replace(/\/\d+$/, "");
    return ROUTE_SECTION_MAP[cleanPath] || null;
  },

  isTutorialCompleted: function (section) {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
      return !!data[section];
    } catch (e) {
      return false;
    }
  },

  markTutorialCompleted: function (section) {
    try {
      var data = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
      data[section] = true;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      // silently fail
    }
  },

  resetAllTutorials: function () {
    localStorage.removeItem(STORAGE_KEY);
  },

  _getAvailableSteps: function (section) {
    var allSteps = TOUR_STEPS[section];
    if (!allSteps) return [];

    return allSteps.filter(function (step) {
      if (!step.element) return true;
      return !!document.querySelector(step.element);
    });
  },

  startTour: function (section, onComplete) {
    if (this._isRunning) return;

    var steps = this._getAvailableSteps(section);
    if (steps.length === 0) return;

    var self = this;
    self._isRunning = true;

    self._driverInstance = driver({
      showProgress: true,
      animate: true,
      overlayColor: "rgba(0, 0, 0, 0.6)",
      stagePadding: 10,
      stageRadius: 10,
      popoverClass: "tutorial-popover",
      showButtons: ["next", "previous", "close"],
      nextBtnText: "Siguiente",
      prevBtnText: "Anterior",
      doneBtnText: "Finalizar",
      progressText: "{{current}} de {{total}}",
      onDestroyed: function () {
        self._isRunning = false;
        self.markTutorialCompleted(section);
        if (typeof onComplete === "function") onComplete();
      },
      steps: steps
    });

    self._driverInstance.drive();
  },

  stopTour: function () {
    if (this._driverInstance && this._isRunning) {
      this._driverInstance.destroy();
      this._isRunning = false;
    }
  },

  isRunning: function () {
    return this._isRunning;
  }
};

export default TutorialService;
